import { useState } from 'react'

export enum PropertyType {
  Erf = 'E',
  Farm = 'F',
  AgriculturalHolding = 'H',
  SectionalTitleUnit = 'U',
}

const readValueOf = (elementId: string): any => {
  const element = document.getElementById(elementId)
  if (!element) return null
  return (element as HTMLInputElement).value
}

export const useDotsProperty = () => {
  const [propertyType, setPropertyType] = useState<PropertyType | null>(
    (readValueOf('hfPropertyTypeCode') as PropertyType) || 'E',
  )
  const [officeCode, setOfficeCode] = useState(
    readValueOf('hfDeedsOfficeID') || '8',
  )
  const [parcelNumber, setParcelNumber] = useState(
    readValueOf('hfParcelNo') || '1234',
  )
  const [portionNumber, setPortionNumber] = useState(
    readValueOf('hfPortionNo') || '0',
  )
  const [sectionNumber, setSectionNumber] = useState(
    readValueOf('hfSectionNo') || '0',
  )
  const [schemeName, setSchemeName] = useState(
    readValueOf('hfSTSchemeName') || '',
  )
  const [allotment, setAllotment] = useState(
    readValueOf('hfAllotment') || 'VERMONT',
  )
  const [address, setAddress] = useState(
    readValueOf('hfAddress') || 'Siffie Crescent, Vermont',
  )
  const [registrationDivision, setRegistrationDivision] = useState(
    readValueOf('hfStreetName') || 'Siffie Crescent',
  )

  const [owners, setOwners] = useState(readValueOf('hfOwners')?.split(';'))

  return {
    propertyType,
    officeCode,
    parcelNumber,
    portionNumber,
    sectionNumber,
    schemeName,
    allotment,
    registrationDivision,
    address,
    owners,
  }
}
